/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import ApproverAssetSelector from "../ApproverAssetSelector/ApproverAssetSelector";
import { Icon, Button, Select } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "components/Toast/Toast";
import { getAssets } from "store/selectors";
import { Link } from "react-router-dom";
import { getCampaignStatusOptions } from "services/common";
import { CampaignStatus } from "models";

const CampaignActions = (props) => {
  const {
    delivery,
    handleDeleteCampaign,
    setNavigationToCampaignPage,
    renderCampaignStatus,
  } = props;
  const dispatch = useDispatch();

  const [changeStatusButtonState, setChangeStatusButtonState] = useState("initial");
  const [campaignChangeStatusVisibility, setCampaignChangeStatusVisibility] = useState(false);

  const setCampaignStatus = async (campaign, newCampaignStatus) => {
    setChangeStatusButtonState("loading");
    try {
      // If new status is NULL, the new status is the latest automatic campaign status
      const newStatus =
        newCampaignStatus !== "NULL"
          ? newCampaignStatus
          : campaign.automaticStatus || CampaignStatus.AWAITING_DELIVERY;
      await dispatch.campaigns.updateStatus({
        id: campaign.id,
        status: newStatus,
      });
      toast(undefined, t("campaign_form_campaign_update_successful"));
      renderCampaignStatus(campaign, newStatus);
      setChangeStatusButtonState("initial");
    } catch (error) {
      console.error(error);
      toast("error", t("campaign_form_campaign_update_failed"));
      setChangeStatusButtonState("initial");
    }
    setCampaignChangeStatusVisibility(false);
  };

  const { t } = useTranslation("common");
  const [newCampaignStatus, setNewCampaignStatus] = useState("");

  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    text: "",
    headerText: "",
    icon: "",
  });

  const [confirmationModalOnSuccess, setConfimationModalOnSuccess] = useState(() => {
    return;
  });
  const [confirmationModalDataForOnSuccess, setConfimationModalDataForOnSuccess] = useState({});

  const assets = useSelector(getAssets);
  const approvers = useSelector((state) => state.approvers);
  const isApproversLoading = useSelector((state) => state.approvers.isLoading);

  const assetsExistInCurrentCampaign =
    assets && assets.items.some((asset) => asset.campaignID === delivery.id);

  const disableDeleteButton = assetsExistInCurrentCampaign || assets.isLoading;

  const currentStatus = delivery?.status ? String(delivery.status) : "";

  useEffect(() => {
    setNewCampaignStatus(currentStatus);
    setCampaignChangeStatusVisibility(false);
  }, [currentStatus]);

  useEffect(() => {
    if (changeStatusButtonState !== "loading") {
      setNewCampaignStatus(currentStatus);
      setCampaignChangeStatusVisibility(false);
    }
  }, [changeStatusButtonState]);

  const getCampaignStatus = (e, data) => {
    const selected = String(data.value ?? "");
    setNewCampaignStatus(selected);

    const isChanged = selected !== currentStatus;
    setCampaignChangeStatusVisibility(isChanged);
  };

  const deleteCampaign = () => {
    setConfirmationModalData({
      text: t("delete_campaing_modal_text"),
      headerText: t("delete_campaing_modal_header"),
      icon: "delete",
    });
    setConfimationModalDataForOnSuccess(delivery);
    setConfimationModalOnSuccess(() => handleDeleteCampaign);
    setConfirmationModalOpen(true);
  };

  const cancelEditStatus = () => {
    setCampaignChangeStatusVisibility(false);
    setNewCampaignStatus(currentStatus);
  };

  return (
    <div className="campaign-actions">
      <Button
        basic
        className="bmo-purple"
        as={Link}
        to={`/campaigns/${delivery.id}`}
        title={t("to_campaign_page")}
        data-test="open_campaign_button"
        onClick={() => setNavigationToCampaignPage()}
      >
        <Icon name="linkify" />
        {t("to_campaign_page")}
      </Button>

      <Select
        placeholder={t("set_campaign_status")}
        options={getCampaignStatusOptions(delivery.type, currentStatus)}
        onChange={getCampaignStatus}
        value={newCampaignStatus}
      />

      <ApproverAssetSelector
        campaign={delivery}
        assets={assets.items.filter((item) => item.campaignID === delivery.id)}
        approvers={approvers.items}
        isApproversLoading={isApproversLoading}
        t={t}
      />

      <div className={`change-campaign-status ${campaignChangeStatusVisibility ? "active" : ""}`}>
        <Button
          loading={changeStatusButtonState === "loading"}
          positive
          onClick={() => setCampaignStatus(delivery, newCampaignStatus)}
          style={{ margin: "0" }}
          disabled={!campaignChangeStatusVisibility}
        >
          <Icon name={`${changeStatusButtonState === "initial" ? "check" : ""}`} />
          {t("change_campaign_status")}
        </Button>

        <Button negative onClick={cancelEditStatus}>
          <Icon name="cancel" />
          {t("cancel")}
        </Button>
      </div>

      <div className="delete-campaign">
        <Button
          basic
          color="red"
          onClick={deleteCampaign}
          data-test="delete_campaign_button"
          disabled={disableDeleteButton}
        >
          <Icon name="trash alternate outline" />
          {t("campaign_actions_delete_campaign")}
        </Button>
      </div>

      <ConfirmationModal
        data={confirmationModalData}
        open={confirmationModalOpen}
        setOpen={setConfirmationModalOpen}
        onSuccess={confirmationModalOnSuccess}
        dataForOnSuccess={confirmationModalDataForOnSuccess}
      />
    </div>
  );
};

export default CampaignActions;
